<template>
  <b-col v-if="service.name" sm="12" md="6" lg="4" class="my-3 d-flex">
    <b-card :id="'id-' + service.id" no-body>
      <b-card-body>
        <debug-bar :api-response="service"></debug-bar>
        <!-- service title -->
        <h3 class="h5">
          <router-link
            class="service-title"
            :to="{
              name: 'Service',
              params: {
                id: service.id,
                name: this.$options.filters.slugg(service.name), // eslint-disable-line
                service: service,
              },
            }"
            :aria-label="service.name"
          >
            {{ service.name }}
          </router-link>
        </h3>
        <!-- service description -->
        <b-card-text :inner-html.prop="service.description | trunc(100, '...')"></b-card-text>
        <!-- service sessions -->
        <service-times-list :service="service"></service-times-list>
        <!-- service areas -->
        <div class="border-top py-1">
          <area-info
            :list-array="service.service_areas"
            value-name="service_area"
            id-name="id"
          ></area-info>
        </div>
        <!-- service types -->
        <div class="border-top pt-2">
          <list-info
            :list-array="service.service_taxonomys"
            value-name="name"
            id-name="id"
            parent-name="taxonomy"
          ></list-info>
        </div>
      </b-card-body>
      <div class="card-footer d-flex justify-content-between align-items-center bg-light">
        <!-- find out more link -->
        <router-link
          class="card-link"
          :to="{
            name: 'Service',
            params: {
              id: service.id,
              name: this.$options.filters.slugg(service.name), // eslint-disable-line
              service: service,
            },
          }"
          aria-label="Find out more"
        >
          Find out more <span class="small"><b-icon icon="chevron-right"></b-icon></span>
        </router-link>
        <!-- Save to favourites -->

        <favourite-pop-up
          :item-id="service.id"
          :item-name="service.name"
          :save-only="true"
        ></favourite-pop-up>
      </div>
    </b-card>
  </b-col>
</template>
<script>
import slugg from '@/filters/sluggify.js'
import trunc from '@/filters/trunc.js'
import ListInfo from '../elements/ListInfo.vue'
import AreaInfo from '../elements/AreaInfo.vue'
import DebugBar from '../DebugBar.vue'
import ServiceTimesList from '../elements/ServiceTimesList.vue'
import FavouritePopUp from '../favourite_list/FavouritePopUp.vue'

export default {
  name: 'ServiceList',
  components: { ListInfo, AreaInfo, DebugBar, ServiceTimesList, FavouritePopUp },
  filters: {
    slugg,
    trunc,
  },
  props: {
    service: {
      type: Object,
      default() {
        return {
          name: '',
          description: '',
        }
      },
    },
  },
}
</script>
